import { createApi } from '@reduxjs/toolkit/query/react';
import { kitchenBaseQuery } from './baseQuery';

// Domain endpoints are injected via menuApi.ts (phase 02b) and future *Api modules.
export const kitchenApi = createApi({
    reducerPath: 'kitchenApi',
    baseQuery: kitchenBaseQuery,
    tagTypes: [
        'Menu',
        'Registry',
        'Booking',
        'BookingActivities',
        'BookingSlots',
        'UserSettings',
        'Users',
        'Orders',
        'Analytics'
    ],
    endpoints: () => ({})
});
